<template>
   <div class="progress-bar-wrapper">
    <div class="progress-barx">
  <div class="w-full bg-grey-100 h-10 flex rounded-full relative //pt-6">
    <div
      v-for="(stage, index) in marker.range.stages"
      :key="stage.name"
      :style="`width: ${stageWidth(stage, marker)}%; background-color: ${
        colorMap[stage.name]
      }`"
      :class="`${index === 0 ? 'rounded-l-full' : ''} ${
        index === marker.range.stages.length - 1 ? 'rounded-r-full' : ''
      }`"
    ></div>
    <div
      :style="`left: ${computedLeft}`"
      style="margin-top: -8px"
      class="absolute border-r-4 border-black h-12"
    >
      <div
        class="absolute w-64 flex items-center"
        style="left: 50%; margin-left: -8px; bottom: 100%; margin-bottom: -3px"
      >
        <div class="rounded-full h-5 w-5 bg-black mr-2" />
        <div
          :style="
            resultPercentage > 60 ? 'margin-left: calc(-100% + 50px)' : ''
          "
        >
          {{ marker.result }} {{ marker.resultUnit }}
        </div>
      </div>
    </div>
  </div>
  </div>
</div>
</template>

<script setup>
import { computed } from 'vue';
import { defineProps } from 'vue';

const props = defineProps({
  resultPercentage: Number,
  colorMap: Object,
  stageWidth: Function,
  marker: Object,
});

const computedLeft = computed(() => {
  return props.resultPercentage > 98
    ? '99.211%'
    : `${props.resultPercentage}%`;
});
</script>
